<script>
import { Sortable } from '@shopify/draggable';

export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    itemClass: {
      type: String,
      default: 'sortable-item',
    },
    handleClass: {
      type: String,
      default: 'sortable-handle',
    },
  },
  provide() {
    return {
      itemClass: this.itemClass,
      handleClass: this.handleClass,
    };
  },
  mounted() {
    var sortable = new Sortable(this.$el, {
      draggable: `.${this.itemClass}`,
      handle: `.${this.handleClass}`,
      mirror: {
        constrainDimensions: true,
      },
    }).on('sortable:stop', ({ oldIndex, newIndex }) => {
      if (oldIndex != newIndex) {
        this.$emit('onOrderChange', [this.value, oldIndex, newIndex]);
      }
    });
      
    this.$on('hook:destroyed', () => {
      sortable.destroy();
    });
  },
  methods: {
    move(items, oldIndex, newIndex) {
      const itemRemovedArray = [
        ...items.slice(0, oldIndex),
        ...items.slice(oldIndex + 1, items.length)
      ];

      var newItem = JSON.parse(JSON.stringify(items[oldIndex]));

      var result = [
        ...itemRemovedArray.slice(0, newIndex),
        newItem,
        ...itemRemovedArray.slice(newIndex, itemRemovedArray.length)
      ];

      var startChangeIndex = oldIndex > newIndex ? newIndex : oldIndex,
        endChangeIndex = oldIndex > newIndex ? oldIndex : newIndex;

      for (var i = startChangeIndex; i <= endChangeIndex; i++) {
        result[i].priority = i;
      }

      return result;
    }
  },
  render() {
    return this.$scopedSlots.default({
      tableRows: this.value,
    });
  }
};
</script>